module.exports = __webpack_public_path__ + "img/hot_line.deee5c3c.jpg";